import React, { useEffect, useState } from 'react';

import tailwindConfig from 'tailwind.config';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);
  const mobileBreakpoint = tailwindConfig.theme.screens.md;

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(
        window.innerWidth <= parseInt(mobileBreakpoint.split('px')[0], 10)
      );
    };

    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    return () => window.removeEventListener('resize', checkIsMobile);
  }, []);

  return isMobile;
};

export default useIsMobile;
